import React from 'react';
import { Card, Checkbox, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { inputSize } from '../../../Shared/UI/jsx';

const { Item } = Form;
const { Option } = Select;

const PersonalAndAddress = ({ form }) => {
    return(
        <Card size="small" className='formCard'>
            <Form
                form={form}
                size="small"
                layout="vertical"
            >
                <Row>
                    <Col span={8}>
                        <Item name="firstStepsId" label="First Steps ID">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="ifspDate" label="IFSP Date">
                            <DatePicker inputReadOnly open={false} format="MM/DD/YYYY" style={{...inputSize, backgroundColor: "white", color: "black"}}/>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="annualIFSPDate" label="Annual IFSP Date">
                            <DatePicker inputReadOnly open={false} format="MM/DD/YYYY" style={{...inputSize, backgroundColor: "white", color: "black"}}/>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="firstName1" label="First Name">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="firstName2" label="First Name 2">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="preferredName" label="Preferred Name">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="lastName1" label="Last Name">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="lastName2" label="Last Name 2">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="lastNameHyphenated" valuePropName="checked">
                            <Checkbox readOnly style={{ opacity: 1, cursor: "default" }} disabled>
                                Last Name Hyphenated?
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="county" label="County">
                         <Select 
                             style={{ ...inputSize, backgroundColor: "white", color: "black" }}
                             showSearch
                             open={false}
                             filterOption={(input, option) => 
                                 option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                             }
                         >
                             <Option value="0">Brown</Option>
                             <Option value="1">Hancock</Option>
                             <Option value="2">Johnson</Option>
                             <Option value="3">Lawrence</Option>
                             <Option value="4">Marion</Option>
                             <Option value="5">Monroe</Option>
                             <Option value="6">Morgan</Option>
                             <Option value="7">Shelby</Option>
                         </Select>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="dateOfBirth" label="Date of Birth">
                            <DatePicker inputReadOnly open={false} format="MM/DD/YYYY" style={{...inputSize, backgroundColor: "white", color: "black"}}/>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="address" label="Address">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="city" label="City">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="zipcode" label="Zipcode">
                            <Input 
                                readOnly 
                                style={{ 
                                ...inputSize, 
                                backgroundColor: "white", 
                                color: "black", 
                                cursor: "default" 
                                }} 
                            />
                        </Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}

export default PersonalAndAddress;